import { transition } from '@helpers/animate';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { m } from 'framer-motion';
import ArrowSvg from '@img/icons/chevron.svg';
import styled from 'styled-components';
import { h3 } from '@helpers/typography';
import brand from '@helpers/brand';
const Container = styled.div `
`;
const Item = styled(m.div) `
  margin-bottom: 0;
  border-bottom: 1px solid ${brand.grey.grey35};
`;
const ItemHeader = styled.button `
  ${ButtonReset};  

  display: flex;
  align-items: center;
  font-size: ${fluid(18, 28)};
  line-height: ${fluid(22, 36)};
  letter-spacing: -0.024em;
  padding: 16px 0 0;
  margin: 0;
  text-align: left;
  width: 100%;

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
  }
`;
const ItemTitle = styled.h3 `
  ${h3};
  font-size: 14px;
  margin-bottom: 12px;
  text-transform: uppercase;
  display: block;
  flex: 1 1 auto;
  color: ${brand.white};
`;
const ItemIcon = styled(ArrowSvg) `
  ${transition('transform')};
  position: relative;
  top: -5px;
  display: block;
  height: ${fluid(12, 12)};
  transform: rotate(90deg);
  color: ${brand.primary.beige};

  ${ItemHeader}:hover & {
    transform: translateY(5px) rotate(90deg);
  }

  ${ItemHeader}[aria-expanded='true'] & {    
    transform: rotate(-90deg);
  }

  ${ItemHeader}[aria-expanded='true']:hover & {    
    transform: translateY(-5px) rotate(-90deg);
  }
`;
const ItemTitleIcon = styled.span ``;
const ItemBody = styled(m.div) `
  min-width: 0;
  overflow: hidden;
`;
const ItemBodyInner = styled.div `
  padding-bottom: ${fluid(16, 16)};
`;
export default {
    Container,
    Item,
    ItemBody,
    ItemBodyInner,
    ItemHeader,
    ItemIcon,
    ItemTitle,
    ItemTitleIcon,
};
